import React from "react";
import { FiAlertCircle } from "react-icons/fi";
import { RECEIVER } from "../../../constants/types";
import AddressListItem from "../Address/AddressListItem";
import LocationSelectorSection from "./LocationSelectorSection";
import ContactDetailsForm from "./ContactDetailsForm";

const DestinationAddress = ({
  usePickupDestination,
  canUsePickupPoints,
  receiver,
  pickupPoint,
  dropoffLocation,
  receiverError,
  customerDetails,
  customerDetailsErrors,
  onToggleFormReceiver,
  onOpenReceiverList,
  onClearReceiverAddress,
  onTogglePickupDestination,
  onSelectCustomerFromList,
  onCustomerDetailsChange,
  onTogglePickupPointList,
  onClearPickupPoint,
  onToggleDropoffLocationList,
  onClearDropoffLocation,
}) => {
  const renderReceiverAddress = () => {
    return (
      <div
        className={`label-create-address receiver ${receiverError ? "show-error" : ""}`}
      >
        <div className="address-header col-12 p-0 d-flex justify-content-between flex-column flex-md-row">
          <h3 className="col-12 col-md-4 p-0">Receiver</h3>
          <div className="address-actions p-0 d-flex flex-row justify-content-end align-items-center mb-3">
            <a className="link-btn" onClick={onOpenReceiverList}>
              Add From List
            </a>
            <p>or</p>
            <a
              className="link-btn"
              onClick={() => {
                onClearReceiverAddress();
                onToggleFormReceiver();
              }}
            >
              Add New Receiver
            </a>
          </div>
        </div>
        {receiverError && (
          <div className="error-block">
            <FiAlertCircle />
            <p>{receiverError}</p>
          </div>
        )}
        {receiver && !!receiver.id && (
          <AddressListItem
            type={RECEIVER}
            item={receiver}
            onFinish={onToggleFormReceiver}
            toggleForm={onToggleFormReceiver}
            toggleAddrList={onOpenReceiverList}
            errors={receiverError}
          />
        )}
      </div>
    );
  };

  return (
    <div
      className={`destination-address ${!!receiverError ? "show-error" : ""}`}
    >
      {canUsePickupPoints ? (
        <div className="pickup-destination-toggle d-flex flex-row justify-content-between align-items-center">
          <div className="pickup-destination-copy">
            <div className="d-flex align-items-center flex-wrap gap-2 mb-1 justify-content-between">
              <h4 className="mb-0">Delivery to pickup point</h4>
              <a
                style={{
                  border: "none",
                  background: "none",
                  color: "#1e8b7c",
                  cursor: "pointer",
                  padding: 0,
                  fontSize: "14px",
                }}
                onClick={() =>
                  window.Supademo.open("cmqlmmv9c0njhqms4mbz9gkz5")
                }
              >
                Watch guide
              </a>
            </div>
            <p className="mb-0">
              Send this shipment to a designated pickup location. Recipient
              contact details are required for delivery notifications.
            </p>
          </div>
          <label className="pickup-destination-switch mb-0">
            <input
              type="checkbox"
              checked={usePickupDestination}
              disabled={!canUsePickupPoints}
              onChange={(e) => onTogglePickupDestination(e.target.checked)}
            />
            <span className="slider"></span>
          </label>
        </div>
      ) : null}

      {receiverError && usePickupDestination && (
        <div className="error-block">
          <FiAlertCircle />
          <p>{receiverError}</p>
        </div>
      )}

      {!usePickupDestination ? (
        renderReceiverAddress()
      ) : (
        <>
          <LocationSelectorSection
            title="Drop-off Location"
            tooltipText="Select a drop-off location where you will drop off the package"
            selectedItem={dropoffLocation}
            onSelectClick={onToggleDropoffLocationList}
            onClearItem={onClearDropoffLocation}
            selectLabel="Select a Drop-off Location"
            changeLabel="Change Drop-off Location"
          />
          <div className="divider"></div>
          <LocationSelectorSection
            title="Pickup Point"
            tooltipText="Select a pickup point from the list"
            selectedItem={pickupPoint}
            onSelectClick={onTogglePickupPointList}
            onClearItem={onClearPickupPoint}
            selectLabel="Select a Pickup Point"
            changeLabel="Change Pickup Point"
            hidePhone
          />
          <ContactDetailsForm
            title="Customer Details"
            values={customerDetails}
            errors={customerDetailsErrors}
            onChange={onCustomerDetailsChange}
            onSelectFromList={onSelectCustomerFromList}
          />
        </>
      )}
    </div>
  );
};

export default DestinationAddress;
